module.exports = __webpack_public_path__ + "img/review-7.a7d26b4e.png";